import React from 'react';

import { cn } from '@/utils/helper';

interface SkeletonCardProps {
  className?: string;
  hasPrice?: boolean;
}

type Props = {
  title: string;
  value: string | number;
  price?: boolean;
  className?: string;
  valueClassName?: string;
};
const GridStatsCard = ({ title, value, price, className, valueClassName }: Props) => {
  return (
    <div className={cn('bg-white-100 dark:bg-jet-black-100 flex flex-col pt-[19px] pb-[22px] px-[22px] border border-coal-50 dark:border-coal-border rounded-[2px] min-w-[165px] justify-between', className)}>
      <span className='text-sm font-normal leading-[21px]'>{title}</span>
      <span className={cn(price ? '!text-forest-green text-base font-normal block mt-[1px]' : 'dark:text-white text-coal-250 font-bold text-[19px]', 'font-space-mono', valueClassName)}>{value}</span>
    </div>
  );
};

export default function SkeletonCard({ className, hasPrice = false }: SkeletonCardProps) {
  return (
    <div className={cn('dark:bg-jet-black-100 bg-white-100 flex flex-col pt-[19px] pb-[22px] px-[22px] border dark:border-gray-700 rounded-[2px] min-w-[165px]', className)}>
      <div className='h-[21px] bg-gray-700 rounded animate-pulse mb-[1px]' />
      <div className={cn(hasPrice ? 'h-4 mt-[1px]' : 'h-[19px]', 'bg-gray-700 rounded animate-pulse w-3/4')} />
    </div>
  );
}

const GridStatsCardsSection = ({ title, children }: { title: string; children: React.ReactNode }) => {
  return (
    <div>
      <p className='pt-[18px] pl-[25.5px] text-[15px] font-semibold pb-[10px]'>{title}</p>
      <div className=''>{children}</div>
    </div>
  );
};
export { GridStatsCardsSection, GridStatsCard };
